import React, {useState, useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import EditorLayout from '../../../../components/Layouts/EditorLayout';
import {SystemSettingsGetSchema} from '../../../../api/DBSchema/SystemSettings';
import RowLayout from '../../../../components/Layouts/RowLayout';
import SMCLabel from '../../../../components/Simple/SMCLabel';
import SMCButton from '../../../../components/Simple/SMCButton';
import TemplateEditorModal from '../../../PopupPages/TemplateEditors/TemplateEditorModal';
import SMCIcon from '../../../../components/Simple/SMCIcon';
import {SMCCheckbox} from '../../../../components/Simple/SMCCheckbox';
import {TemplateSchema} from '../../../../api/DBSchema/Template';
import {SMCSelect, SMCOption} from '../../../../components/Simple/SMCSelect';
import Sepperator from '../../../../components/Simple/Sepperator';

const pageSchema = SystemSettingsGetSchema.pages.notificationReports;
const pageId = pageSchema.pageId;

function SystemSettingsNotificationReports({
    systemSettingsObject,
    setSystemSettingsData
}) {
    const { t } = useTranslation();

    const pageData = systemSettingsObject[pageId];

    const shortReport                  = pageData[pageSchema.shortReport];
    const shortReportSchema            = pageSchema.shortReportSchema;
    const shortReportEnabled           = shortReport[TemplateSchema.enabled];
    const shortReportReportsUnit       = shortReport[shortReportSchema.reportsUnits];
    const shortPortalReportDayNumber   = shortReport[shortReportSchema.shortPortalReportDayNumber];
    const shortReportReportsUnitValues = shortReportSchema.reportsUnitsValues;
    
    const extendedReport                  = pageData[pageSchema.extendedReport];
    const extendedReportSchema            = pageSchema.extendedReportSchema;
    const extendedReportEnabled           = extendedReport[TemplateSchema.enabled];
    const extendedReportReportsUnit       = extendedReport[extendedReportSchema.reportsUnits];
    const extendedPortalReportDayNumber   = extendedReport[extendedReportSchema.extendedPortalReportDayNumber];
    const extendedReportReportsUnitValues = extendedReportSchema.reportsUnitsValues;

    const [isShortReportEditorOpen, setIsShortReportEditorOpen] = useState(false);
    const [isExtendedReportEditorOpen, setIsExtendedReportEditorOpen] = useState(false);

    // Fix day number
    useEffect(() => {
        if (
            (shortReportReportsUnit === shortReportReportsUnitValues.weekly  && (shortPortalReportDayNumber > 7 || shortPortalReportDayNumber < 1)) ||
            (shortReportReportsUnit === shortReportReportsUnitValues.monthly && (shortPortalReportDayNumber > 31 || shortPortalReportDayNumber < 1))
        ) {
            setSystemSettingsData([pageId, pageSchema.shortReport, shortReportSchema.shortPortalReportDayNumber], 7);
        }
    }, [shortPortalReportDayNumber, setSystemSettingsData, shortReportSchema, shortReportReportsUnit, shortReportReportsUnitValues]);

    // Fix day number
    useEffect(() => {
        if (
            (extendedReportReportsUnit === extendedReportReportsUnitValues.weekly  && (extendedPortalReportDayNumber > 7 || extendedPortalReportDayNumber < 1)) ||
            (extendedReportReportsUnit === extendedReportReportsUnitValues.monthly && (extendedPortalReportDayNumber > 31 || extendedPortalReportDayNumber < 1))
        ) {
            setSystemSettingsData([pageId, pageSchema.extendedReport, extendedReportSchema.extendedPortalReportDayNumber], 7);
        }
    }, [extendedPortalReportDayNumber, setSystemSettingsData, extendedReportSchema, extendedReportReportsUnit, extendedReportReportsUnitValues]);

    return (
        <EditorLayout lineHeight="32px">
            <RowLayout spacing="8px">
                <SMCCheckbox
                    checked={shortReportEnabled}
                    onChange={e => setSystemSettingsData([pageId, pageSchema.shortReport, TemplateSchema.enabled], e.target.checked)}
                    label={t('SMP.SYSTEM.SETTINGS.NOTIFICATIONS.REPORTS.SEND_SHORT')}
                    labelWidth={100}
                />
                <SMCLabel inline width={150}>
                    <SMCSelect
                        value={shortReportReportsUnit}
                        onChange={e => setSystemSettingsData([pageId, pageSchema.shortReport, shortReportSchema.reportsUnits], e.target.value)}
                        width={100}
                    >
                        <SMCOption value={shortReportReportsUnitValues.daily}>{t('SMP.DAILY')}</SMCOption>
                        <SMCOption value={shortReportReportsUnitValues.weekly}>{t('SMP.WEEKLY')}</SMCOption>
                        <SMCOption value={shortReportReportsUnitValues.monthly}>{t('SMP.MONTHLY')}</SMCOption>
                    </SMCSelect>
                </SMCLabel>
                <SMCLabel>{t('SMP.SYSTEM.SETTINGS.NOTIFICATIONS.REPORTS.LINE1')}</SMCLabel>
                <SMCButton onClick={() => setIsShortReportEditorOpen(true)}>
                    <RowLayout spacing="4px"><SMCIcon icon="rightArrow" />{t('SMP.SYSTEM.SETTINGS.NOTIFICATIONS.CUSTOMIZE')}</RowLayout>
                </SMCButton>
            </RowLayout>
            <div>
                {
                    shortReportReportsUnit === shortReportReportsUnitValues.weekly && (
                        <RowLayout spacing="4px">
                            <SMCLabel inline>{t('SMP.SETTINGS.NOTIFICATIONS.REPORTS.EVERY')}</SMCLabel>
                            <SMCSelect
                                inline
                                value={shortPortalReportDayNumber}
                                onChange={e => setSystemSettingsData([pageId, pageSchema.shortReport, shortReportSchema.shortPortalReportDayNumber], parseInt(e.target.value))}
                            >
                                <SMCOption value={1}>{t('SMP.SUNDAY')}</SMCOption>
                                <SMCOption value={2}>{t('SMP.MONDAY')}</SMCOption>
                                <SMCOption value={3}>{t('SMP.TUESDAY')}</SMCOption>
                                <SMCOption value={4}>{t('SMP.WEDNESDAY')}</SMCOption>
                                <SMCOption value={5}>{t('SMP.THURSDAY')}</SMCOption>
                                <SMCOption value={6}>{t('SMP.FRIDAY')}</SMCOption>
                                <SMCOption value={7}>{t('SMP.SATURDAY')}</SMCOption>
                            </SMCSelect>
                        </RowLayout>
                    )
                }
                {
                    shortReportReportsUnit === shortReportReportsUnitValues.monthly && (
                        <RowLayout spacing="4px">
                            <SMCLabel inline>{t('SMP.SYSTEM.SETTINGS.NOTIFICATIONS.REPORTS.ON_DAY')}</SMCLabel>
                            <SMCSelect inline value={shortPortalReportDayNumber} onChange={e => setSystemSettingsData([pageId, pageSchema.shortReport, shortReportSchema.shortPortalReportDayNumber], parseInt(e.target.value))}>
                                {
                                    [...Array(31)].map((e,i) => (                                        
                                        <SMCOption key={i+1} value={i+1}>{i+1}</SMCOption>
                                    ))
                                }
                            </SMCSelect>
                            <SMCLabel inline>{t('SMP.SYSTEM.SETTINGS.NOTIFICATIONS.REPORTS.OF_MONTH')}</SMCLabel>
                        </RowLayout>
                    )
                }
            </div>

            <Sepperator />
            
            <RowLayout spacing="8px">
                <SMCCheckbox
                    checked={extendedReportEnabled}
                    onChange={e => setSystemSettingsData([pageId, pageSchema.extendedReport, TemplateSchema.enabled], e.target.checked)}
                    label={t('SMP.SYSTEM.SETTINGS.NOTIFICATIONS.REPORTS.SEND_EXTENDED')}
                    labelWidth={100}
                />
                <SMCLabel inline width={150}>
                    <SMCSelect
                        value={extendedReportReportsUnit}
                        onChange={e => setSystemSettingsData([pageId, pageSchema.extendedReport, extendedReportSchema.reportsUnits], e.target.value)}
                        width={100}
                    >
                        <SMCOption value={extendedReportReportsUnitValues.daily}>{t('SMP.DAILY')}</SMCOption>
                        <SMCOption value={extendedReportReportsUnitValues.weekly}>{t('SMP.WEEKLY')}</SMCOption>
                        <SMCOption value={extendedReportReportsUnitValues.monthly}>{t('SMP.MONTHLY')}</SMCOption>
                    </SMCSelect>
                </SMCLabel>
                <SMCLabel>{t('SMP.SYSTEM.SETTINGS.NOTIFICATIONS.REPORTS.LINE1')}</SMCLabel>
                <SMCButton onClick={() => setIsExtendedReportEditorOpen(true)}>
                    <RowLayout spacing="4px"><SMCIcon icon="rightArrow" />{t('SMP.SYSTEM.SETTINGS.NOTIFICATIONS.CUSTOMIZE')}</RowLayout>
                </SMCButton>
            </RowLayout>
            <div>
                    {
                        extendedReportReportsUnit === extendedReportReportsUnitValues.weekly && (
                            <RowLayout spacing="4px">
                                <SMCLabel inline>{t('SMP.SETTINGS.NOTIFICATIONS.REPORTS.EVERY')}</SMCLabel>
                                <SMCSelect
                                    inline
                                    value={extendedPortalReportDayNumber}
                                    onChange={e => setSystemSettingsData([pageId, pageSchema.extendedReport, extendedReportSchema.extendedPortalReportDayNumber], parseInt(e.target.value))}
                                >
                                    <SMCOption value={1}>{t('SMP.SUNDAY')}</SMCOption>
                                    <SMCOption value={2}>{t('SMP.MONDAY')}</SMCOption>
                                    <SMCOption value={3}>{t('SMP.TUESDAY')}</SMCOption>
                                    <SMCOption value={4}>{t('SMP.WEDNESDAY')}</SMCOption>
                                    <SMCOption value={5}>{t('SMP.THURSDAY')}</SMCOption>
                                    <SMCOption value={6}>{t('SMP.FRIDAY')}</SMCOption>
                                    <SMCOption value={7}>{t('SMP.SATURDAY')}</SMCOption>
                                </SMCSelect>
                            </RowLayout>
                        )
                    }
                    {
                        extendedReportReportsUnit === extendedReportReportsUnitValues.monthly && (
                            <RowLayout spacing="4px">
                                <SMCLabel inline>{t('SMP.SYSTEM.SETTINGS.NOTIFICATIONS.REPORTS.ON_DAY')}</SMCLabel>
                                <SMCSelect inline value={extendedPortalReportDayNumber} onChange={e => setSystemSettingsData([pageId, pageSchema.extendedReport, extendedReportSchema.extendedPortalReportDayNumber], parseInt(e.target.value))}>
                                    {
                                        [...Array(31)].map((e,i) => (                                        
                                            <SMCOption key={i+1} value={i+1}>{i+1}</SMCOption>
                                        ))
                                    }
                                </SMCSelect>
                                <SMCLabel inline>{t('SMP.SYSTEM.SETTINGS.NOTIFICATIONS.REPORTS.OF_MONTH')}</SMCLabel>
                            </RowLayout>
                        )
                    }
                </div>

            {/* Popup windows */}
            <TemplateEditorModal
                isOpen={isShortReportEditorOpen}
                onRequestClose={() => setIsShortReportEditorOpen(false)}
                defaultObject={shortReport}
                onSuccess={val => {
                    setSystemSettingsData([pageId, pageSchema.shortReport], val);
                    setIsShortReportEditorOpen(false);
                }}
                templateName="portalsShortReport"
                isGlobal={true}
            />
            <TemplateEditorModal
                isOpen={isExtendedReportEditorOpen}
                onRequestClose={() => setIsExtendedReportEditorOpen(false)}
                defaultObject={extendedReport}
                onSuccess={val => {
                    setSystemSettingsData([pageId, pageSchema.extendedReport], val);
                    setIsExtendedReportEditorOpen(false);
                }}
                templateName="portalsExtendedReport"
                isGlobal={true}
            />
        </EditorLayout>
    )
}

export default SystemSettingsNotificationReports;